export const types = {
	showSidebar: "[UI] Show SideBar",
	toggleSidebar: "[UI] Toggle SideBar",
	toggleNavbar: "[UI] Toggle Navbar",
	ChangeLanguage: "[UI] Language English to Spanish",
};
